import { ComponentProps } from 'react';

import { MultiSelect, OptionList } from '@ingrid/luterkort-react';

import { useLocalizedCountryList } from '~src/i18n/localized-country';

type MultiSelectRootProps = ComponentProps<typeof MultiSelect.Root>;
type MultiSelectTriggerProps = ComponentProps<typeof MultiSelect.Trigger>;

type CountryMultiSelectProps = MultiSelectRootProps & Omit<MultiSelectTriggerProps, 'options'>;

export function CountryMultiSelect(props: CountryMultiSelectProps) {
  const countries = useLocalizedCountryList();

  return (
    <MultiSelect.Root onValueChange={props.onValueChange} value={props.value}>
      <MultiSelect.Trigger options={countries} placeholder={props.placeholder} />

      <MultiSelect.Content css={{ height: 300, overflowY: 'scroll', width: 368 }}>
        <OptionList.Viewport>
          {countries.map(([code, name]) => (
            <OptionList.Item key={code} value={code}>
              <OptionList.ItemText>{name}</OptionList.ItemText>
              <OptionList.ItemIndicator>
                <OptionList.CheckmarkIcon />
              </OptionList.ItemIndicator>
            </OptionList.Item>
          ))}
        </OptionList.Viewport>
      </MultiSelect.Content>
    </MultiSelect.Root>
  );
}
